import listActions from 'src/modules/affirmationProgram/list/affirmationProgramListActions';
import AffirmationProgramService from 'src/modules/affirmationProgram/affirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'AFFIRMATIONPROGRAM_DESTROY';

const affirmationProgramDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_STARTED,
      });

      await AffirmationProgramService.destroyAll([id]);

      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmationProgram.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_ALL_STARTED,
      });

      await AffirmationProgramService.destroyAll(ids);

      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.affirmationProgram.destroyAll.success'),
      );

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: affirmationProgramDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default affirmationProgramDestroyActions;
